<template>
  <header
    class="flex items-center justify-between gap-4 bg-white px-4 py-4 lg:px-8"
    data-testid="affiliate-header"
  >
    <div class="flex flex-col text-left">
      <h1 class="m-0 text-2xl font-bold text-textPrimary">
        <template v-if="showBreadcrumb">
          <router-link :to="homePath" class="hover:text-primary">Portal do Afiliado</router-link>
          <span class="mx-2 text-[#7F7F8E]">&rsaquo;</span>
          <span aria-current="page">{{ title }}</span>
        </template>
        <template v-else>{{ title }}</template>
      </h1>
      <span
        v-if="subtitle"
        class="mt-0.5 max-w-[80ch] text-sm text-[#163D45]"
        data-testid="affiliate-header-subtitle"
      >
        {{ subtitle }}
      </span>
    </div>
    <div class="relative flex items-center">
      <button
        type="button"
        class="flex items-center gap-1 text-primary"
        data-testid="affiliate-header-avatar"
        @click="open = !open"
      >
        <span
          class="grid h-10 w-10 place-items-center rounded-full bg-primary font-bold text-white"
          >{{ initials }}</span
        >
        <svg class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path :d="mdiChevronDown" />
        </svg>
      </button>
      <div
        v-if="open && canLogout"
        class="absolute right-0 top-12 z-10 w-48 rounded-xl border border-gray-200/80 bg-white py-1 shadow-md"
      >
        <button
          type="button"
          class="w-full px-4 py-3 text-left text-sm font-medium text-red-500 hover:bg-red-50"
          data-testid="affiliate-logout"
          @click="emit('logout')"
        >
          Sair
        </button>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { mdiChevronDown } from '@mdi/js'
import { ref } from 'vue'

defineProps<{
  title: string
  subtitle: string
  showBreadcrumb: boolean
  homePath: string
  initials: string
  canLogout: boolean
}>()

const emit = defineEmits<{ logout: [] }>()
const open = ref(false)
</script>
